import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { PaymentPeriod } from "app/components/PackageSwitcher/consts/paymentPeriod";
import type { IChangePackageAddonInfo } from "app/components/PackageSwitcher/types/addonsTypes";
import { translate } from "app/filters/i18nFilter";

import { Addon, AddonPrice, AddonsList, Content } from "./AddonsTooltipContent.styled";

interface IAddonsTooltipContentProps {
    addonsInfo: IChangePackageAddonInfo[];
    period: PaymentPeriod;
}

export const AddonsTooltipContent = ({ addonsInfo, period }: IAddonsTooltipContentProps) => {
    const isMonthly = period === PaymentPeriod.MONTHLY;

    return (
        <Content>
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.bluegrey[100]}
            >
                {translate("buyer_journey.switch_package.addons.tooltip.title")}
            </Text>
            <AddonsList>
                {addonsInfo.map((addon) => (
                    <Addon key={`${addon.addonName}`}>
                        <Text
                            fontVariant="tooltip"
                            color={colorsPalettes.bluegrey[100]}
                        >
                            {addon.addonName}
                        </Text>
                        <AddonPrice>
                            {isMonthly ? (
                                <Text
                                    fontVariant="tooltip"
                                    color={colorsPalettes.bluegrey[100]}
                                >
                                    {addon.monthlyPriceFormatted}/
                                    {translate("buyer_journey.switch_package.addons.tooltip.month.period.short")}
                                </Text>
                            ) : (
                                <>
                                    <Text
                                        fontVariant="tooltip"
                                        color={colorsPalettes.bluegrey[100]}
                                    >
                                        {addon.annuallyPriceFormatted}/
                                        {translate("buyer_journey.switch_package.addons.tooltip.year.period.short")}
                                    </Text>
                                    <Text
                                        fontVariant="queryBar1"
                                        color={colorsPalettes.bluegrey[100]}
                                    >
                                        ({addon.monthlyPriceFormatted}/
                                        {translate("buyer_journey.switch_package.addons.tooltip.month.period.short")})
                                    </Text>
                                </>
                            )}
                        </AddonPrice>
                    </Addon>
                ))}
            </AddonsList>
        </Content>
    );
};
